<template>
    <v-btn @click="$emit('click')" class="rounded ml-1" color="primary" small ><v-icon left>mdi-plus</v-icon>Thêm</v-btn>
</template>
<script>
export default {
}
</script>
